// extracted by mini-css-extract-plugin
export default {"top":"Expenses_top__Z31D8","box":"Expenses_box__t0Lnq","addButton":"Expenses_addButton__k2f8E"};